import GoogleTagManager from './GoogleTagManager'

export default GoogleTagManager
// eslint-disable-next-line import/export
export * from './GoogleTagManager'
